import { defineStore } from 'pinia'
import { useNotificationsSubscriptionsListStore } from '@/stores/notifications/subscriptions-list'

interface SubscriptionStatus {
  active: boolean
}

interface SubscriptionResponse {
  data: SubscriptionStatus
}

export const useNotificationsSubscriptionsStore = defineStore(
  'notifications-subscriptions',
  {
    actions: {
      async subscribe(id: string) {
        const notificationsSubscriptionsListStore =
          useNotificationsSubscriptionsListStore()
        const { $sdk } = useNuxtApp()
        const res = (await $sdk
          .module('notifications')
          .then(({ subscribe }) => subscribe(id))) as SubscriptionResponse

        await notificationsSubscriptionsListStore.updateItem(id, {
          status: res.data
        })
        return res.data
      },
      async unsubscribe(id: string) {
        const notificationsSubscriptionsListStore =
          useNotificationsSubscriptionsListStore()
        const { $sdk } = useNuxtApp()
        await $sdk
          .module('notifications')
          .then(({ unsubscribe }) => unsubscribe(id))

        await notificationsSubscriptionsListStore.updateItem(id, {
          status: null
        })
      }
    }
  }
)
